const SET_MESSAGE = '[messages][session]set.message';
const CLEAR_MESSAGES = '[messages][session]clear';

export {SET_MESSAGE, CLEAR_MESSAGES}